interface AppResponse { content : string };
(function () {
    $(function () {
        $('body').on('submit', '.js-form', function (event : JQuery.Event): void {
            event.preventDefault();
            event.stopPropagation();

            const $form : JQuery<HTMLElement> = $(this);

            if (true === formIsBeingSubmitted($form)) {
                return;
            }

            const formData = new FormData(this);
            markFormAsBeingSubmitted($form);
            $.ajax({
                method: $form.attr('method'),
                url: $form.attr('data-submit-url'),
                data: formData,
                contentType: false,
                processData: false
            }).done(function (response : AppResponse): void {
                $form.parents('.js-form-content').html(response.content);
            }).fail(function (response : JQueryXHR): void {
                if (typeof response.responseJSON !== 'undefined') {
                    const appResponse : AppResponse = response.responseJSON;
                    $form.parents('.js-form-content').html(appResponse.content);
                } else {
                    addFormResponseError($form, $form.attr('data-error-response'));
                }
            }).always(function (): void {
                markFormAsNoLongerBeingSubmitted($form);
            });
        });

        $('body').on('change', '.js-fetch-form-on-change', function (event : JQuery.Event): void {
            event.preventDefault();
            event.stopPropagation();

            const $form : JQuery<HTMLElement> = $(this).parents('form').first();

            if (true === formIsBeingSubmitted($form)) {
                return;
            }

            markFormAsBeingSubmitted($form);
            $.ajax({
                method: $form.attr('method'),
                url: $form.attr('data-fetch-url'),
                data: $form.serialize()
            }).done(function (response : AppResponse): void {
                $form.parent().find('.form-response-error').remove();
                $form.parents('.js-form-content').html(response.content);
            }).fail(function (response : JQueryXHR): void {
                addFormResponseError($form, $form.attr('data-error-response'));
            }).always(function (): void {
                markFormAsNoLongerBeingSubmitted($form);
            });
        });

        function formIsBeingSubmitted($form : JQuery<HTMLElement>): boolean {
            return 1 === $form.data('is-being-submitted');
        }

        function markFormAsBeingSubmitted($form : JQuery<HTMLElement>): void {
            $form.data('is-being-submitted', 1);
            $form.find('button[type="submit"]').attr('disabled', 'disabled').prop('disabled', true);
        }

        function markFormAsNoLongerBeingSubmitted($form : JQuery<HTMLElement>): void {
            $form.data('is-being-submitted', 0);
            $form.find('button[type="submit"]').removeAttr('disabled').prop('disabled', false);
        }

        function addFormResponseError($form : JQuery<HTMLElement>, content : string): void {
            $form.parent().find('.form-response-error').remove();
            $form.prepend('<div class="form-response-error">' + content + '</div>');
        }
    });
})();



// WEBPACK FOOTER //
// ./assets/typescript/form-submit.ts